import router from '@/router'
import axios from 'axios'

export const API = process.env.VUE_APP_API
export const Inscriptio = process.env.VUE_APP_INSCRIPTIO_API

export const InscriptioAPI = `${Inscriptio}${API}`
export const NOWWUrl = process.env.VUE_APP_NOWW_URL

export const DefaultErrorMessage = 'There was a problem with your request. Please try again.'
export const DefaultUnauthenticatedMessage = 'You must log in first.'
export const DefaultUnauthorizedMessage = 'Your session has expired.'
export const DefaultForbiddenMessage = 'You are not authorized for that.'

const client = axios.create({
  baseURL: InscriptioAPI
})

export default client

export const parseItem = (response, code) => {
  if (response.status !== code) throw Error(response.message)
  let item = response.data
  if (typeof item !== 'object') {
    item = undefined
  }
  return item
}

export const handleError = error => {
  if (!error.response) return { errorResponse: DefaultErrorMessage }
  console.error(error.response)
  if (error.response.status === 401) return { errorResponse: error.response.data || DefaultUnauthorizedMessage }
  if (error.response.status === 403) return { errorResponse: error.response.data || DefaultForbiddenMessage }
  return { errorResponse: error.response.data }
}

export const noLoadingConfig = {
  headers: {
    'NoLoading': true
  }
}

export const formUploadConfig = {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
}
